import React, { JSX } from 'react';
import Style from './Section.module.scss';

const Section: React.FC<{ children?: React.ReactNode }> = ({ children }): JSX.Element => {
  return <section className={Style.section}>{children}</section>;
};

export default Section;
